var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m274.114 474.265c-5.466 3.308-11.729 5.056-18.114 5.056-6.387 0-12.652-1.749-18.118-5.059-11.167-6.759-69.692-43.077-124.937-94.177-76.218-70.5-114.226-138.547-112.912-202.184 1.679-81.323 69.433-146.488 150.764-145.203 39.966.632 77.174 17.138 104.171 45.014.568.586 1.497.586 2.064 0 26.996-27.875 64.202-44.381 104.166-45.014 81.329-1.288 149.085 63.873 150.769 145.194 1.317 63.64-36.69 131.69-112.912 202.193-55.245 51.101-113.769 87.418-124.941 94.18z",
    fill: "#f9c6da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m481.007 181.095c0-64.851-52.572-117.423-117.423-117.423-45.18 0-84.399 25.516-104.036 62.923-1.512 2.879-5.587 2.879-7.098 0-19.636-37.407-58.856-62.923-104.036-62.923-64.851 0-117.423 52.572-117.423 117.423 0 128.105 200.347 252.98 222.942 266.656 1.272.77 2.859.77 4.131 0 22.597-13.676 222.943-138.551 222.943-266.656z",
    fill: "#dd5790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m394.427 67.764c27.611 21.485 45.374 55.031 45.374 92.727 0 123.853-187.267 244.686-220.118 264.931 16.922 11.681 29.507 19.457 34.252 22.329 1.272.77 2.859.77 4.131 0 22.595-13.676 222.942-138.551 222.942-266.656-.001-54.178-36.692-99.786-86.581-113.331z",
    fill: "#da387d"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.7288581f54db7f27af2f0e0b7cf73e32.svg";
export { ForwardRef as ReactComponent };